import { createContext } from 'react'

export const PusherContext = createContext()
